module.exports = __webpack_public_path__ + "img/facilityInfo_0_0.403b36ea.jpg";